exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-58a36de3]{\n  text-align: center;\n  background-color: #E5E5E5;\n}\n", ""]);

// exports
